const common = {
  brand: "USFansSheet",
  nav: {
    home: "Home",
    shopGuide: "Shopping Guide",
    categories: "Categories",
    resources: "Resources",
    guides: "Guides",
    safety: "Safety",
    faq: "FAQ",
  },
  languages: {
    en: "English",
    pl: "Polski",
    es: "Español",
    fr: "Français",
  },
  footer: {
    tagline: "An independent resource hub for USFans Spreadsheet research, guides and safety tips.",
    navTitle: "Explore",
    categoriesTitle: "Categories",
    disclaimer: "USFansSheet.live is an independent informational resource. It is not necessarily affiliated with, operated by, or endorsed by USFans. Information may change and should be independently verified before making purchasing, payment or account decisions.",
    rights: "All rights reserved.",
  },
};

export default common;